import type {ReactElement} from 'react';
import React from 'react';
import type {NotificationsThumbnailProps} from './notifications-thumbnail.types';
import styles from './notifications-thumbnail.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';

export function NotificationsThumbnail({...props}: NotificationsThumbnailProps): ReactElement {
  return (
    <div className={`${props.thumbnailClassName ?? ''} ${styles.notificationsThumbnail} _position-relative`}>
      <div className={`_full-width _full-height flex-center _overflow-hidden border-s-dark radius-8`}>
        {props.imageUrl && props.imageUrl !== '' ? (
            <img className={styles.notificationImage} src={props.imageUrl} alt="notification-image"></img>
        ) : (
          <Icon className={'content-primary'} icon={props.iconName ?? ''} />
        )}
      </div>
      <div
        className={`${props.isHovered ? `${props.hoveredMiniIconClasses ?? ''} ${styles.hoverBorder}` : `outline-neutral-thick ${props.miniIconClasses ?? ''}`} ${styles.positioningIcon}  spacing-p-1 top-0 left-0 radius-round _position-absolute flex-center`}
      >
        <Icon icon={props.miniIconName} size={IconSize.SIZE_ICON_12} />
      </div>
    </div>
  );
}
